/* MrCOLOMBO Merkliste - localStorage-basiert, Gaeste-faehig
   Key: mrc:wishlist  -> [{ id: variantId, handle, title, addedAt }]
   Event: mrc:wishlist:update (detail: { count, items })
   API: window.MRCWishlist.{read,write,has,toggle,remove,clear}
*/
(function () {
  'use strict';
  var KEY = 'mrc:wishlist';
  var EVT = 'mrc:wishlist:update';

  function read() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; }
    catch (e) { return []; }
  }
  function write(items) {
    localStorage.setItem(KEY, JSON.stringify(items));
    document.dispatchEvent(new CustomEvent(EVT, { detail: { count: items.length, items: items } }));
  }
  function has(id) {
    return read().some(function (i) { return String(i.id) === String(id); });
  }
  function toggle(item) {
    var items = read();
    var idx = items.findIndex(function (i) { return String(i.id) === String(item.id); });
    if (idx >= 0) {
      items.splice(idx, 1);
      write(items);
      return false;
    }
    items.push({
      id: item.id,
      handle: item.handle || '',
      title: item.title || '',
      addedAt: new Date().toISOString()
    });
    write(items);
    return true;
  }
  function remove(id) {
    write(read().filter(function (i) { return String(i.id) !== String(id); }));
  }
  function clear() { write([]); }

  window.MRCWishlist = { read: read, write: write, has: has, toggle: toggle, remove: remove, clear: clear, KEY: KEY, EVENT: EVT };

  function syncButton(btn) {
    var id = btn.getAttribute('data-mrc-wishlist-id');
    if (!id) return;
    if (has(id)) {
      btn.classList.add('is-active');
      btn.setAttribute('aria-pressed', 'true');
      btn.setAttribute('aria-label', 'Aus Merkliste entfernen');
    } else {
      btn.classList.remove('is-active');
      btn.setAttribute('aria-pressed', 'false');
      btn.setAttribute('aria-label', 'Auf Merkliste setzen');
    }
  }
  function syncBadges() {
    var n = read().length;
    document.querySelectorAll('[data-mrc-wishlist-count]').forEach(function (el) {
      el.textContent = n;
      if (n === 0) el.setAttribute('hidden', '');
      else el.removeAttribute('hidden');
    });
  }
  function syncAll() {
    document.querySelectorAll('[data-mrc-wishlist-toggle]').forEach(syncButton);
    syncBadges();
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-mrc-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    toggle({
      id: btn.getAttribute('data-mrc-wishlist-id'),
      handle: btn.getAttribute('data-mrc-wishlist-handle'),
      title: btn.getAttribute('data-mrc-wishlist-title')
    });
  });

  document.addEventListener(EVT, syncAll);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPage);
  } else {
    initPage();
  }

  function initPage() {
    syncAll();
    var pageEl = document.querySelector('[data-mrc-wishlist-page]');
    if (pageEl) renderPage(pageEl);
  }

  function fmtPrice(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  function renderPage(container) {
    var items = read();
    var grid = container.querySelector('[data-mrc-wishlist-grid]');
    var empty = container.querySelector('[data-mrc-wishlist-empty]');
    if (!grid || !empty) return;

    if (!items.length) {
      grid.setAttribute('hidden', '');
      empty.removeAttribute('hidden');
      return;
    }
    empty.setAttribute('hidden', '');
    grid.removeAttribute('hidden');
    grid.innerHTML = '<div class="mrc-wishlist__loading">Lade gemerkte Produkte ...</div>';

    var handles = Array.from(new Set(items.map(function (i) { return i.handle; }).filter(Boolean)));
    Promise.all(handles.map(function (h) {
      return fetch('/products/' + h + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    })).then(function (products) {
      var byHandle = {};
      products.forEach(function (p, i) { if (p) byHandle[handles[i]] = p; });
      grid.innerHTML = '';
            items.forEach(function (item) {
        var p = byHandle[item.handle];
        if (!p) return;
        var v = p.variants.find(function (x) { return String(x.id) === String(item.id); }) || p.variants[0];
        if (!v) return;
        var imgUrl = '';
        if (v.featured_image && v.featured_image.src) imgUrl = v.featured_image.src;
        else if (p.featured_image) imgUrl = p.featured_image;
        var compare = (v.compare_at_price && v.compare_at_price > v.price)
          ? '<span class="mrc-wishlist__compare">' + fmtPrice(v.compare_at_price) + '</span>'
          : '';

        var tags = (p.tags || []).map(function (t) { return String(t).toLowerCase().trim(); });
        var isComingSoon = tags.indexOf('demnaechst-verfuegbar') >= 0 || tags.indexOf('im-zulauf') >= 0;
        var incomingLabel = window.MRC_LABEL_INCOMING || 'Im Zulauf';
        var titleLower = String(p.title || '').toLowerCase();
        var isSet = tags.indexOf('set') >= 0 || tags.indexOf('geschenkkorb') >= 0 || tags.indexOf('gift') >= 0 || tags.indexOf('box') >= 0
          || titleLower.indexOf('set') >= 0 || titleLower.indexOf('geschenkkorb') >= 0 || titleLower.indexOf('probierbox') >= 0;
        var hasBioTag = tags.indexOf('bio') >= 0 || tags.indexOf('bio-zertifiziert') >= 0 || tags.indexOf('eu-bio') >= 0 || tags.indexOf('organic') >= 0;
        var hasBio = hasBioTag || (!isSet && (titleLower.indexOf('bio ') >= 0 || titleLower.indexOf('bio-') >= 0));
        var siegelHtml = '<div class="mrc-wishlist__siegel" aria-hidden="true">';
        if (hasBio) {
          siegelHtml += '<img src="' + window.MRC_ASSET_BIO + '" alt="" width="34" height="34" loading="lazy">';
        }
        siegelHtml += '<img src="' + window.MRC_ASSET_SRI + '" alt="" width="34" height="22" loading="lazy">';
        siegelHtml += '</div>';

        var weightPill = '';
        var grams = 0;
        if (v.weight && v.weight > 0) grams = v.weight;
        else if (v.grams && v.grams > 0) grams = v.grams;
        if (!isSet && grams > 0) {
          var label = '';
          if (grams >= 1000) label = (grams / 1000) + ' kg';
          else label = grams + ' g';
          weightPill = '<span class="mrc-wishlist__weight">' + label + '</span>';
        } else if (v.title && v.title !== 'Default Title') {
          weightPill = '<span class="mrc-wishlist__weight">' + escapeHtml(v.title) + '</span>';
        }

        var available = v.available ? '' : ' disabled';
        var addLabel = v.available ? 'In den Warenkorb' : 'Ausverkauft';
        var incomingAria = ((document.documentElement.lang || '').toLowerCase().indexOf('de') === 0 ? 'Verfügbarkeit von ' : 'Show availability for ') + p.title;
        // === Collection-Card-Style (wie .mrc-collection-card auf Collection-Page) ===
        var wrapperClasses = 'card-wrapper product-card-wrapper';
        if (hasBio) wrapperClasses += ' mrc-has-bio';
        if (isComingSoon) wrapperClasses += ' mrc-coming-soon';
        // Build size list from all variants: "100 g · 250 g"
        var sizesArr = [];
        p.variants.forEach(function(vv) {
          var g = (vv.weight && vv.weight > 0) ? vv.weight : (vv.grams || 0);
          if (g > 0) {
            var lbl = g >= 1000 ? (g/1000) + ' kg' : g + ' g';
            if (sizesArr.indexOf(lbl) < 0) sizesArr.push(lbl);
          } else if (vv.title && vv.title !== 'Default Title') {
            if (sizesArr.indexOf(vv.title) < 0) sizesArr.push(vv.title);
          }
        });
        var sizesHtml = sizesArr.length ? '<p class="mrc-collection-card__sizes">' + sizesArr.join(' · ') + '</p>' : '';
        // Price: "ab X €" wenn multiple variants mit different prices, sonst "X €"
        var prices = p.variants.map(function(vv){return vv.price;});
        var minP = Math.min.apply(null, prices);
        var priceLabel = (prices.length > 1 && Math.max.apply(null, prices) !== minP) ? 'ab ' + fmtPrice(minP) : fmtPrice(v.price);
        var card = document.createElement('article');
        card.className = wrapperClasses;
        card.setAttribute('data-variant-id', String(item.id));
        card.innerHTML =
          '<button type="button" class="mrc-card-wishlist is-active" aria-pressed="true" aria-label="Aus Merkliste entfernen" data-action="remove">' +
            '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" stroke-linecap="round" stroke-linejoin="round"></path></svg>' +
          '</button>' +
          '<div class="mrc-collection-card">' +
            '<a href="/products/' + p.handle + '?variant=' + v.id + '" class="mrc-collection-card__link" aria-label="' + escapeHtml(p.title) + ' ansehen">' +
              '<div class="mrc-collection-card__img">' +
                (imgUrl ? '<img src="' + imgUrl + '" alt="' + escapeHtml(p.title) + '" loading="lazy" width="600" height="600">' : '') +
                (isComingSoon ? '<span class="mrc-collection-card__incoming">' + escapeHtml(incomingLabel) + '</span>' : '') +
              '</div>' +
              '<div class="mrc-collection-card__body">' +
                '<h3 class="mrc-collection-card__title">' + escapeHtml(p.title) + '</h3>' +
                sizesHtml +
                (isComingSoon ? '' : '<div class="mrc-collection-card__price"><span class="mrc-collection-card__price-current">' + priceLabel + '</span></div>') +
              '</div>' +
            '</a>' +
            (isComingSoon ? '<button type="button" class="mrc-collection-card__quick-add" data-mrc-coming-soon data-mrc-product-title="' + escapeHtml(p.title) + '" aria-label="' + escapeHtml(incomingAria) + '">' +
                '<span class="mrc-collection-card__quick-add-icon" aria-hidden="true"><svg class="mrc-collection-card__quick-add-bag" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" focusable="false"><path d="M6.331 8h11.339a2 2 0 0 1 1.977 2.304l-1.255 8.152a3 3 0 0 1-2.966 2.544H8.574a3 3 0 0 1-2.965-2.544l-1.255-8.152A2 2 0 0 1 6.331 8"/><path d="M9 11V6a3 3 0 0 1 6 0v5"/></svg><svg class="mrc-collection-card__quick-add-plus" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" focusable="false"><path d="M3 12a9 9 0 1 0 18 0 9 9 0 0 0-18 0"/><path d="M9 12h6M12 9v6"/></svg></span>' +
              '</button>' : '<form action="/cart/add" method="post" class="mrc-collection-card__quick-add-form" data-mrc-cart-form style="margin:0;">' +
              '<input type="hidden" name="id" value="' + v.id + '">' +
              '<input type="hidden" name="quantity" value="1">' +
              '<button type="submit" class="mrc-collection-card__quick-add"' + available + ' aria-label="' + addLabel + '">' +
                '<span class="mrc-collection-card__quick-add-icon" aria-hidden="true"><svg class="mrc-collection-card__quick-add-bag" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" focusable="false"><path d="M6.331 8h11.339a2 2 0 0 1 1.977 2.304l-1.255 8.152a3 3 0 0 1-2.966 2.544H8.574a3 3 0 0 1-2.965-2.544l-1.255-8.152A2 2 0 0 1 6.331 8"/><path d="M9 11V6a3 3 0 0 1 6 0v5"/></svg><svg class="mrc-collection-card__quick-add-plus" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" focusable="false"><path d="M3 12a9 9 0 1 0 18 0 9 9 0 0 0-18 0"/><path d="M9 12h6M12 9v6"/></svg></span>' +
              '</button>' +
            '</form>') +
          '</div>';
        grid.appendChild(card);
      });
      if (!grid.children.length) {
        grid.setAttribute('hidden', '');
        empty.removeAttribute('hidden');
      }
    });

    grid.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-action="remove"]');
      if (!btn) return;
      e.preventDefault();
      var card = btn.closest('.card-wrapper, .mrc-wl-item, .mrc-home-card-shell');
      var vid = card && card.getAttribute('data-variant-id');
      if (vid) remove(vid);
      if (card) card.remove();
      if (!grid.children.length) {
        grid.setAttribute('hidden', '');
        empty.removeAttribute('hidden');
      }
    });
  }

  function escapeHtml(s) {
    return String(s || '').replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
})();
